.b2{right:0px;}